export default __webpack_public_path__ + "static/media/heading2.b034a08b.svg";